import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CircleCheckmarkIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M15.7 9.3c.4.4.4 1 0 1.4l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.4l1.3 1.3 3.3-3.3a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CircleCheckmarkIcon;
